import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import MuiIconButton from '@material-ui/core/IconButton'

import { translate } from 'irmlib/multilanguage'

/**
 * Implements a button for in-house svg icons.
 * Use only for UX team supplied svg icons converted to jsx.
 *
 * @param {object} props component props
 * @returns {ClickableSvgIcon} ClickableSvgIcon component
 */
const ClickableSvgIcon = forwardRef((props, ref) => {
  return (
    <MuiIconButton title={translate(props.title)} disabled={props.disabled} id={props.id} ref={ref} onClick={props.onClick}>{props.children}</MuiIconButton>
  )
})

ClickableSvgIcon.propTypes = {
  /**
   id for the control.
   */
  id: PropTypes.string,
  /**
   The icon to display.
   */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  /**
   Function that is executed when the icon is clicked.
   */
  onClick: PropTypes.func,
  /**
   Disabled control.
   */  
  disabled: PropTypes.bool,
  /**
   Hover title for the control.
   */  
  title: PropTypes.string,
}

export default ClickableSvgIcon
